<script setup lang="ts">
const props = defineProps<{
  label: string
  startedAt?: number
}>()

const { elapsed } = useDocueAgentActivityDuration(() => ({
  isWorking: true,
  startedAt: props.startedAt,
}))
</script>

<template>
  <div class="flex h-8 max-w-full items-center gap-2 rounded-full border border-neutral-200 bg-white px-3 text-neutral-700 shadow-[0_2px_10px_rgba(0,0,0,0.06)]">
    <span
      class="min-w-0 truncate text-sm font-medium"
      aria-live="polite"
    >
      {{ label }}
    </span>
    <span
      v-if="elapsed"
      class="shrink-0 border-l border-neutral-200 pl-2 text-xs tabular-nums text-neutral-400"
    >
      {{ elapsed }}
    </span>
  </div>
</template>
